const ajax_object = {
    ajax_url: `//${window.location.host}/wp-admin/admin-ajax.php`
};

jQuery(document).ready(function($) {

    $('.posts__pagination a').on('click', function(event) {
        event.preventDefault();
        let category = 'all';
        let paged = parseInt($(this).text());
        let ajax_url = ajax_object.ajax_url;

        ajaxPosts(category, paged, ajax_url);
    });

    function ajaxPosts(category, paged, ajax_url) {
        $.ajax({
            url: ajax_url,
            type: 'POST',
            data: {
                action: 'ajax_press_pagination',
                paged: paged
            },
            beforeSend: function() {
                $('.js-press-ajax').css({ 'opacity': '0.3', 'pointer-events': 'none' });
            },
            success: function(data) {
                $('.js-press-ajax').find('.posts__list').html(data);
            },
            complete: function() {
                $('.js-press-ajax').css({ 'opacity': '1', 'pointer-events': 'auto' });
            }
        });
    }
});